import { computed, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AnonymousUserButton } from "./Buttons/AnonymousUserButton";
import { UserButton } from "./Buttons/UserButton";
import { Link } from "./General/Link";
import { AboutIcon } from "./Icons/AboutIcon";
import { ChangePasswordIcon } from "./Icons/ChangePasswordIcon";
import { LogOutIcon } from "./Icons/LogOutIcon";
import { UserProfileIcon } from "./Icons/UserProfileIcon";
import { AppStore } from "./Stores/AppStore";
import { Strings } from "./Stores/StringsStore";
import { Urls } from "./Urls";
import { DocumentFilter } from "./Stores/DocumentFilterStore";
import { DocumentSearchStore } from "./Stores/DocumentSearchStore";

export interface ILogInComponentProps {
	testId?: string;
	testName?: string;
}

@observer
export class LogInComponent extends React.Component<ILogInComponentProps, {}> {
	documentSearchStore: DocumentSearchStore = new DocumentSearchStore(
		DocumentFilter
	);
	@observable on: boolean;

	@computed get loginText(): string {
		return AppStore.context.sessionDetails.isAnonymous
			? Strings.general.logIn
			: AppStore.context.sessionDetails.userDisplayName;
	}

	toggle = () => {
		if (!AppStore.context.sessionDetails.isApp) {
			this.on = !this.on;
		}
	};

	toggleOff = () => {
		this.on = false;
	};

	redirect(url: string) {
		AppStore.keepOnPage(url, false, () => {
			location.href = url;
		});
	}

	@computed get userNavCSS() {
		return this.on
			? "app__head-status is--usernav"
			: AppStore.context.sessionDetails.isApp
			? "app__head-status mobile"
			: "app__head-status";
	}

	render() {
		var children =
			this.on && !AppStore.context.sessionDetails.isAnonymous ? (
				<ul>
					{AppStore.context.sessionDetails.isApp ? null : (
						<li>
							<a
								href={Urls.logout}
								data-test-id="userNav_logOut"
								onClick={() => {
									this.documentSearchStore.resetFilter();
								}}
							>
								<LogOutIcon />
								<span>
									{Strings.appNavigation.logOutLinkText}
								</span>
							</a>
						</li>
					)}
					<li>
						<Link
							to={Urls.about}
							useHistoryOverride={true}
							testId="userNav_about"
							className="aboutLink"
						>
							<AboutIcon />
							<span>{Strings.appNavigation.aboutLinkText}</span>
						</Link>
					</li>
				</ul>
			) : null;

		let userNav = (
			<div className="usernav">
				{this.loginText ? (
					<div>
						<span>{this.loginText}</span>
					</div>
				) : null}
				{children}
			</div>
		);

		return AppStore.context.sessionDetails.isAnonymous ? (
			<div className={this.userNavCSS}>
				<a href={Urls.authenticate}>
					<AnonymousUserButton testId="userNav" />
					{userNav}
				</a>
			</div>
		) : (
			<div
				className={this.userNavCSS}
				onMouseLeave={this.toggleOff}
				onClick={this.toggle}
			>
				<UserButton testId="userNav" />
				{userNav}
			</div>
		);
	}
}
